module.exports = __webpack_public_path__ + "img/circle-fill.622a0b54.svg";